enum DragAndDropAreaEventEnum {
	pointerMove = 'pointerMove',
	pointerDown = 'pointerDown',
	pointerUp = 'pointerUp',
	enterDropArea = 'enterDropArea',
	leaveDropArea = 'leaveDropArea'
}

export default DragAndDropAreaEventEnum;
